export default __webpack_public_path__ + "static/media/eKYC_Result_Extratime@2x.6e08ae87.png";